import { Security } from "./Security";

export default Security;